<script>
export default {
  template: '<template></template>',
}
</script>

<style lang="scss">
@import './RequirementSearch';
</style>
